import axios, { AxiosError } from "axios";
import { COMMON_STRINGS } from "../constants/strings";
import { ENV } from "../config/env";

// 🔥 Redux store access
import { store } from "../store";
import { logout } from "../store/authSlice";

const axiosInstance = axios.create({
  baseURL: ENV.API_BASE_URL,
  timeout: 10000,
});

// ================= REQUEST =================
axiosInstance.interceptors.request.use(
  (config) => {
    try {
      // ✅ Redux se token lo (NOT localStorage)
      const token = store.getState().auth.token;

      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    } catch (error) {
      console.error("Request Interceptor Error:", error);
      return config;
    }
  },
  (error) => Promise.reject(error),
);

// ================= RESPONSE =================
axiosInstance.interceptors.response.use(
  (response) => response,

  (error: AxiosError<any>) => {
    const status = error.response?.status;
    const serverMessage = error.response?.data?.message;
    let finalMessage = serverMessage || COMMON_STRINGS.SERVER_ERROR;


    // 🔐 Unauthorized
    if (status === 401) {
      finalMessage = COMMON_STRINGS.UNAUTHORIZED;

      // ✅ Redux logout (no reload)
      store.dispatch(logout());
    }

    // 🚫 Forbidden
    else if (status === 403) {
      finalMessage = serverMessage || COMMON_STRINGS.FORBIDDEN;
      // 🔥 BLOCK USER HANDLE HERE
      if (error.response?.data?.isBlocked) {
        console.log("USER BLOCKED 🚫");

        store.dispatch(logout());
      }
    }

    

    // ❌ Not found
    else if (status === 404) {
      finalMessage = COMMON_STRINGS.NOT_FOUND;
    }

    // ⚠️ Server error
    else if (status === 500) {
      finalMessage = COMMON_STRINGS.SERVER_ERROR;
    }

    // 🌐 Network error
    if (!error.response) {
      finalMessage = COMMON_STRINGS.NETWORK_ERROR;
    }

    return Promise.reject({
      success: false,
      message: finalMessage,
      status,
    });
  },
);

export default axiosInstance;
